import React from 'react';
import '../style/Homepage.css';

const Login = () => {
    return (
        <div className="homepage-container" style={{ justifyContent: 'center', alignItems: 'center' }}>
            <div className="glass-card" style={{ width: '400px', height: 'auto', padding: '3rem', animation: 'none' }}>
                <h2 style={{ fontSize: '2rem', marginBottom: '0.5rem', color: '#fff' }}>Welcome Back</h2>
                <p style={{ marginBottom: '2rem' }}>Login to access your dashboard</p>

                <form style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <div style={{ textAlign: 'left' }}>
                        <label style={{ color: '#cbd5e1', fontSize: '0.9rem', marginBottom: '0.5rem', display: 'block' }}>Email</label>
                        <input type="email" placeholder="you@example.com" style={{
                            width: '100%',
                            padding: '0.8rem',
                            borderRadius: '8px',
                            border: '1px solid rgba(255,255,255,0.1)',
                            background: 'rgba(0,0,0,0.2)',
                            color: '#fff',
                            outline: 'none'
                        }} />
                    </div>
                    <div style={{ textAlign: 'left' }}>
                        <label style={{ color: '#cbd5e1', fontSize: '0.9rem', marginBottom: '0.5rem', display: 'block' }}>Password</label>
                        <input type="password" placeholder="••••••••" style={{
                            width: '100%',
                            padding: '0.8rem',
                            borderRadius: '8px',
                            border: '1px solid rgba(255,255,255,0.1)',
                            background: 'rgba(0,0,0,0.2)',
                            color: '#fff',
                            outline: 'none'
                        }} />
                    </div>
                    <button className="btn btn-primary" style={{ marginTop: '1rem', width: '100%' }}>Sign In</button>
                </form>
            </div>
        </div>
    );
};

export default Login;
